<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门</div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryinit"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">

        <el-card style="height: calc(100vh - 700px);">
          <div slot="header"
               class="card-header"><i class="el-icon-s-custom"></i>巡检</div>
          <div class="es-op-box">
            <el-row>
              <el-col>
                <el-date-picker style="float: left;width:300px;margin-bottom: 10px;"
                                value-format="yyyy-MM-dd"
                                v-model="dateTime"
                                type="daterange"
                                size="small"
                                class="query"
                                range-separator="至"
                                start-placeholder="计划开始日期起始"
                                end-placeholder="计划开始日期结束"
                                clearable
                                @clear="() => { this.dateTime = []; }"
                                @change="() => { 
                                             queryinit(this.selectorgId)                                                  
                                            }">
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row :gutter="15"
                    style="width:100%;height:100px;padding-top:15px"
                    height="calc(100vh - 560px)">
              <el-col :span="6">
                <div class="cbottomshadow"
                     id="departfaulttop1">
                  <div class="label">巡检线路数</div>
                  <div class="value">{{lineLineCount}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="cbottomshadow"
                     id="departfaulttop1">
                  <div class="label">巡检计划总数</div>
                  <div class="value">{{linePlanCount}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="cbottomshadow"
                     id="departfaulttop1">
                  <div class="label">巡检项总数</div>
                  <div class="value">{{linePlanitemCount}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="cbottomshadow"
                     id="departfaulttop1">
                  <div class="label">逾期计划</div>
                  <div class="value"
                       style="color:orange">{{lineOverTimePlanCount}}</div>
                </div>
              </el-col>
            </el-row>
          </div>

        </el-card>

        <el-row :gutter="15">
          <el-col :span="8">
            <el-card style="height:567px;margin-top: 15px;">
              <div id="departLineListChart"
                   style="height:400px;width:100%"></div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card style="height:567px;margin-top: 15px;">
              <div id="sys"
                   style="height:400px;width:100%"></div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card style="height:567px; margin-top: 15px;">
              <div id="ontime"
                   style="height:400px;width:100%"></div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'insstatistic',
  data () {
    return {
      orgTree: [],
      selectorgId: [],
      queryObj: { pageNum: 1, pageSize: 20, starttime: [], endtime: [] },//查询条件

      departLineList: [],
      departLineSys: [],
      lineLineCount: 0,
      linePlanCount: 0,
      linePlanitemCount: 0,
      lineOverTimePlanCount: 0,
      dateTime: [],
      loading: false,
      flag: 0,



    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTime = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.loadDepartLineList()
      this.loadDepartLineSys()
      this.loadLineLineCount()
      this.loadLinePlanCount()
      this.loadLinePlanitemCount()
      this.loadLineOverTimePlanCount()

    },

    queryinit (orgIds) {
      this.selectorgId = orgIds
      this.loadDepartLineSys(orgIds)
      this.loadLineLineCount(orgIds)
      this.loadLinePlanCount(orgIds)
      this.loadLinePlanitemCount(orgIds)
      this.loadLineOverTimePlanCount(orgIds)
    },
    loadDepartLineList (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/departlinelist', this.queryObj).then(msg => {
        this.departLineList = msg
        this.initdepartLineListChart()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadDepartLineSys (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/departlinesys', this.queryObj).then(msg => {
        this.departLineSys = msg
        this.initdpartsyschart(this.departLineSys, "sys", '系统分布')
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadLineLineCount (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      console.log(this.queryObj)
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/linelinecount', this.queryObj).then(msg => {
        this.lineLineCount = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadLinePlanCount (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/lineplancount', this.queryObj).then(msg => {
        this.linePlanCount = msg
        this.flag++
        this.initsuccessRatechart()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadLinePlanitemCount (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/lineplanitemcount', this.queryObj).then(msg => {
        this.linePlanitemCount = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadLineOverTimePlanCount (orgIds) {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/lineovertimeplancount', this.queryObj).then(msg => {
        this.lineOverTimePlanCount = msg
        this.flag++
        this.initsuccessRatechart()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },



    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },

    initdepartLineListChart () {
      let myChart = this.$echarts.init(document.getElementById('departLineListChart'))
      var colorList = ['#3bafff', '#afa3f5', '#00d488', '#3feed4', '#f1bb4c', '#aff', "rgba(250,250,250,0.5)"];
      var option = {
        title: {
          subtext: '组织线路规则分布',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 28,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['39%', '63%'],
            center: ['50%', '50%'],
            type: 'pie',
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 5,
                length2: 60,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: false
              }
            },
            label: {
              normal: {
                formatter: function (params) {
                  var str = params.name + params.value;
                  return str
                },
                padding: [0, -90],
                height: 35,
              }
            },
            data: this.departLineList,
          },
          // 边框的设置
          {
            radius: ['58%', '65%'],
            center: ['50%', '50%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      };
      myChart.setOption(option)
    },

    initdpartsyschart (datelist, idname, title) {
      let myChart = this.$echarts.init(document.getElementById(idname))
      var option = {
        color: ["#F86464", "#19DC7C", "#34A6FE", "#FA9022", "#DCDB01", "#8C70F8", "#2A4AD1", "#E76FE3", "#5032C0", "#168FB2"],
        title: {
          subtext: title,
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 28,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          left: '2%',
          top: '1%',
          bottom: 10,
          right: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 14
          },
          formatter: "{b} : {c} ({d}%)"
        },

        calculable: true,
        series: [
          {
            type: 'pie',
            radius: ["6%", "8%"],
            center: ['55%', '50%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#68c5ff"
                }
              }
            }]
          },
          {
            type: 'pie',
            radius: ["69.5%", "70%"],
            center: ['55%', '50%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false
              }
            },
            name: "",
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#0674bf"
                }
              }
            }]
          }, {
            stack: 'a',
            type: 'pie',
            radius: ['25%', '60%'],
            center: ['55%', '50%'],
            roseType: 'area',
            zlevel: 10,
            label: {
              normal: {
                formatter: '{d}%',
                borderWidth: 0,
                borderRadius: 4,
                padding: [0, -50],
                height: 40,
                fontSize: 12,
                align: 'center',
                rich: {
                  b: {
                    fontSize: 13,
                    lineHeight: 5,
                    color: '#41B3DC'
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 55
              },
              emphasis: {
                show: false
              }
            },
            data: datelist
          },]
      };

      myChart.setOption(option)
    },

    initsuccessRatechart () {

      if (this.flag != 2) {
        return
      }
      this.flag = 0

      let myChart = this.$echarts.init(document.getElementById("ontime"))

      var getvalue = (this.linePlanCount - this.lineOverTimePlanCount) / this.linePlanCount * 100;
      if ((getvalue + '').length > 3) {
        getvalue = (getvalue + '').substring(0, 3)
      }
      var option = {
        backgroundColor: '#FFFFFF',
        title: [{
          subtext: '按时完成率',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 28,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        }],
        angleAxis: {
          show: false,
          max: getvalue * 360 / 270, //-45度到225度，二者偏移值是270度除360度
          type: 'value',
          startAngle: 225, //极坐标初始角度
          splitLine: {
            show: false
          }
        },
        barMaxWidth: 20, //圆环宽度
        radiusAxis: {
          show: false,
          type: 'category',
        },
        //圆环位置和大小
        polar: {
          center: ['50%', '50%'],
          radius: '120%'
        },
        series: [{
          type: 'bar',
          data: [{ //上层圆环，显示数据
            value: getvalue,
            itemStyle: {
              color: '#1598FF',
            },
          }],
          barGap: '-100%', //柱间距离,上下两层圆环重合
          coordinateSystem: 'polar',
          roundCap: true, //顶端圆角
          z: 3 //圆环层级，同zindex
        },
        { //下层圆环，显示最大值
          type: 'bar',
          data: [{
            value: getvalue,
            itemStyle: {
              color: '#1598FF',
              opacity: 0.2,
              borderWidth: 0,
            },
          }],
          barGap: '-100%',
          coordinateSystem: 'polar',
          roundCap: true,
          z: 1
        },
        //仪表盘
        {
          type: 'gauge',
          startAngle: 225, //起始角度，同极坐标
          endAngle: -45, //终止角度，同极坐标
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLabel: {
            show: false
          },
          pointer: { // 分隔线
            shadowColor: 'auto', //默认透明
            shadowBlur: 5,
            length: '50%',
            width: "2",
          },
          itemStyle: {
            color: '#1598FF',
            borderColor: "#1598FF",
            borderWidth: 6
          },
          detail: {
            formatter: function (params) {
              console.log(params)
              return getvalue + '%';
            },
            color: '#1598FF',
            fontSize: 20,
            offsetCenter: [0, 110],
          },
          title: {
            show: false
          },
          data: [{
            value: getvalue,
          }]
        }, {
          name: '外部刻度',
          type: 'gauge',
          //  center: ['20%', '50%'],
          radius: '73%',
          min: 0, //最小刻度
          max: 100, //最大刻度
          splitNumber: 10, //刻度数量
          startAngle: 225,
          endAngle: -45,
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: [
                [1, 'rgba(0,0,0,0)']
              ]
            }
          }, //仪表盘轴线
          axisLabel: {
            show: false,
            color: '#4d5bd1',
            distance: 25,
          }, //刻度标签。
          axisTick: {
            show: true,
            splitNumber: 7,
            lineStyle: {
              color: '#C7CBCF', //用颜色渐变函数不起作用
              width: 2,
            },
            length: -8
          }, //刻度样式
          splitLine: {
            show: false,
            length: -20,
            lineStyle: {
              color: '#C7CBCF', //用颜色渐变函数不起作用
            }
          }, //分隔线样式
          detail: {
            show: false
          },
          pointer: {
            show: false
          }
        }, {//指针外环
          "type": 'pie',
          "hoverAnimation": false,
          "legendHoverLink": false,
          "radius": ['10%', '15%'],
          "z": 10,
          "label": {
            "normal": {
              "show": false
            }
          },
          "labelLine": {
            "normal": {
              "show": false
            }
          },
          "data": [{
            "value": 100,
            itemStyle: {
              normal: {
                color: "#1598FF",
              }
            }
          }]
        },
        {//指针内环
          "type": 'pie',
          "hoverAnimation": false,
          "legendHoverLink": false,
          "radius": ['0%', '10%'],
          "z": 10,
          "label": {
            "normal": {
              "show": false
            }
          },
          "labelLine": {
            "normal": {
              "show": false
            }
          },
          "data": [{
            "value": 100,
            itemStyle: {
              normal: {
                color: "#FFFFFF"
              }
            }
          }]
        }
        ]
      };
      myChart.setOption(option)
    }




  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottom {
  width: 100%;
  height: 160px;
  background: -webkit-gradient(
    linear,
    0% 0%,
    0% 80%,
    from(#8deca8),
    to(#f2f6fc)
  );
}
.cbottomshadow {
  width: calc(100% - 32px);
  height: 68px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: -webkit-gradient(
    linear,
    0% 0%,
    100% 100%,
    from(#409eff),
    to(#409eff)
  );
  border-radius: 10px;
}
.cbottomshadow .label {
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.cbottomshadow .value {
  margin-top: 8px;
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-weight: bolder;
}

.title {
  size: 14;
}
</style>
